/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_RewindInputs */



/**
* | output |
* | --- |
* | "Rewind" |
*
* @param {Options_Pedal_Action_RewindInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_rewind = /** @type {((inputs?: Options_Pedal_Action_RewindInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_RewindInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour rapide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurückspulen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riavvolgi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотка назад")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rebobinar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("倒带")
	if (locale === "ja") return /** @type {LocalizedString} */ ("巻き戻し")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवाइंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Retroceder")
	return /** @type {LocalizedString} */ ("Rewind")
});